import React from 'react'
import styles from './styles.css'

const EBookItem = ({ itemData, handleClick }) => {
  const {
    imgWrap,
    btnWrap,
    titleStyle,
    contentWrap,
    itemContainer,
    priceGroupWrap,
    descriptionStyle,
  } = styles
  const { thumbnail, title, descriptionOne, descriptionTwo, url } = itemData
  return (
    <div>
      <div className={itemContainer}>
        <div className={imgWrap}>
          <img src={thumbnail} alt="" />
        </div>
        <div className={contentWrap}>
          <div className={titleStyle}>{title}</div>
          <div className={descriptionStyle}>{descriptionOne}</div>
          <div className={descriptionStyle}>{descriptionTwo}</div>
        </div>
        <div className={priceGroupWrap}>
          <div className={btnWrap} onClick={handleClick(url)}>
            阅读
          </div>
        </div>
      </div>
    </div>
  )
}

export default EBookItem



// WEBPACK FOOTER //
// ./src/modules/E-Book/item.js